<template>
  <div class="calendar">
    <div class="cal-header">
      <div>
        <b-btn variant="light" @click="prevMonth">
          <b-icon icon="arrow-left-square" />
        </b-btn>
      </div>
      <div class="header">
        <single-date-picker
          :value="inputValue"
          format="MMMM yyyy"
          maximum-view="month"
          minimum-view="month"
          @input="$emit('input', $event)"
        />
      </div>
      <div>
        <b-btn variant="light" @click="nextMonth">
          <b-icon icon="arrow-right-square" />
        </b-btn>
      </div>
    </div>
    <div class="cal-body">
      <div
        v-for="(day, i) in labels"
        :key="`label-${i}`"
        class="label-cell font-weight-bold"
      >
        {{ day }}
      </div>
      <div
        v-for="(day, i) in days"
        :key="`day-${i}`"
        :class="{
          'is-today': today(day.date),
          'is-weekend': day.date.isoWeekday() >= 6,
          'is-month': day.isCurrentMonth,
          active: day.date.format(format) === inputValue,
          disabled: !day.isCurrentMonth,
        }"
        class="day-cell"
        @click.prevent="changeDay(day, $event)"
      >
        <span class="day">{{ day.date.format('D') }}</span>
        <slot :day="day" :name="`cell(${day.date.format(format)})`" />
      </div>
    </div>
  </div>
</template>
<script>
import SingleDatePicker from '@/components/inputs/SingleDatePicker'

export default {
  components: {
    SingleDatePicker,
  },
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      format: 'YYYY-MM-DD',
      currentDate: this.$moment(),
      days: [],
      prevdays: [],
      nexdays: [],
    }
  },
  computed: {
    labels() {
      return this.$moment.localeData('sk').weekdaysShort(true)
    },
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.currentDate = this.$moment(val)
      },
    },
  },
  watch: {
    currentDate: {
      immediate: true,
      handler(val) {
        const monthDate = val.startOf('month')
        let days = []
        days = [...Array(monthDate.daysInMonth())].map((_, i) => {
          return {
            date: monthDate.clone().add(i, 'day'),
            isCurrentMonth: true,
          }
        })

        const firstWeekday = days[0].date.isoWeekday()

        const prevMonthDays = firstWeekday ? firstWeekday - 1 : 6
        const prevLastDay = this.$moment(days[0].date).subtract(
          prevMonthDays,
          'day',
        )

        let prevdays = []
        prevdays = [...Array(prevMonthDays)].map((day, i) => {
          return {
            date: prevLastDay.clone().add(i, 'day'),
            isCurrentMonth: false,
          }
        })

        const lastWeekDay = days[days.length - 1].date.isoWeekday()
        const nextMonthDays = lastWeekDay ? 7 - lastWeekDay : lastWeekDay

        let nextdays = []
        nextdays = [...Array(nextMonthDays)].map((day, i) => {
          return {
            date: monthDate.clone().add(i, 'day'),
            isCurrentMonth: false,
          }
        })

        this.days = [...prevdays, ...days, ...nextdays]
      },
    },
    value(val, old) {
      this.inputValue = val
      if (
        this.$moment(val).month() !== this.$moment(old).month() ||
        this.$moment(val).year() !== this.$moment(old).year()
      ) {
        this.$emit('monthChanged', this.$moment(val, this.format))
      }
    },
  },
  mounted() {
    this.currentDate = this.$moment(this.inputValue) || this.$moment()
  },
  methods: {
    prevMonth() {
      this.$nextTick(() => {
        this.$emit(
          'input',
          this.$moment(this.inputValue)
            .subtract(1, 'months')
            .startOf('month')
            .format(this.format),
        )
      })
    },
    nextMonth() {
      this.$nextTick(() => {
        this.$emit(
          'input',
          this.$moment(this.inputValue)
            .add(1, 'months')
            .startOf('month')
            .format(this.format),
        )
      })
    },
    changeDay(item) {
      if (item.isCurrentMonth) {
        this.$emit('input', item.date.format(this.format))
      }
    },
    today(day) {
      return this.$moment().isSame(day, 'day')
    },
  },
}
</script>
